import React, { useState } from "react";
import { FaMinus, FaPlus, FaCogs, FaClipboardList, FaMicroscope, FaDna, FaUserMd, FaCapsules, FaFlask, FaNotesMedical, FaHeartbeat } from "react-icons/fa";
import Medpalm from "../../../assests/HealthcarePLS/personal.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "title": "Genomic Sequencing & Analysis",
        "description": "Harnessing next-generation sequencing (NGS) and advanced bioinformatics to decode an individual’s genetic blueprint. This process identifies genetic variations linked to inherited disorders, cancer susceptibility, and drug metabolism. By analyzing whole genomes or specific gene panels, healthcare providers can predict disease risk, personalize treatments, and improve preventive care strategies."
    },
    {
        "title": "Biomarker Discovery",
        "description": "Identifying molecular indicators in blood, tissue, and other biological samples to detect diseases at their earliest stages. Biomarkers play a vital role in diagnosing conditions like cancer, neurodegenerative diseases, and autoimmune disorders. They enable targeted therapies, help monitor disease progression, and enhance the effectiveness of personalized treatment approaches."
    },
    {
        "title": "Customized Drug Development",
        "description": "Advancing pharmaceutical research by tailoring medications to individual genetic profiles. This precision medicine approach ensures that treatments are highly effective while reducing the risk of side effects. It is particularly beneficial for oncology, rare genetic disorders, and chronic conditions where standard treatments may not be as effective. This strategy accelerates drug development, improving patient outcomes."
    },
    {
        "title": "Pharmacogenomics Consulting",
        "description": "Providing expert guidance on how genetic differences impact drug metabolism, absorption, and efficacy. By analyzing a patient’s genetic makeup, healthcare providers can prescribe medications with greater accuracy, minimizing adverse drug reactions and optimizing therapeutic effects. This field is revolutionizing medication management for conditions such as cardiovascular diseases, psychiatric disorders, and pain management."
    },
    {
        "title": "Personalized Treatment Plans",
        "description": "Integrating genetic insights with clinical history and lifestyle factors to create highly individualized healthcare strategies. Personalized treatment plans address disease prevention, targeted therapies, nutrition, and fitness recommendations tailored to a person’s unique biological and environmental factors. This approach enhances chronic disease management, optimizing patient care and improving long-term health outcomes."
    },
    {
        "title": "AI & Data Analytics in Medicine",
        "description": "Utilizing artificial intelligence (AI), big data, and predictive analytics to advance precision medicine. AI-driven algorithms analyze vast amounts of genetic, clinical, and molecular data to identify patterns, enhance diagnostics, and predict individual treatment responses. These innovations improve early disease detection, refine drug development, and enable healthcare professionals to make data-driven medical decisions with unprecedented accuracy."
    }
]

const features = [
    { icon: <FaDna className="text-[#2a627a] text-lg" />, text: "Genetic profiling for tailored treatment strategies." },
    { icon: <FaMicroscope className="text-[#2a627a] text-lg" />, text: "Advanced molecular diagnostics for disease prediction." },
    { icon: <FaCapsules className="text-[#2a627a] text-lg" />, text: "Customized drug formulations based on genetic makeup." },
    { icon: <FaFlask className="text-[#2a627a] text-lg" />, text: "Cutting-edge biomarker research for early disease detection." },
    { icon: <FaCogs className="text-[#2a627a] text-lg" />, text: "AI-driven insights for personalized healthcare solutions." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Data-driven patient health monitoring for optimal outcomes." }
];
const benefits = [
    { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Enhances treatment efficacy with targeted therapies." },
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Minimizes adverse drug reactions through precision prescribing." },
    { icon: <FaDna className="text-[#2a627a] text-lg" />, text: "Improves patient outcomes with data-driven decision-making." },
    { icon: <FaCapsules className="text-[#2a627a] text-lg" />, text: "Optimizes medication dosages based on individual genetic makeup." },
    { icon: <FaFlask className="text-[#2a627a] text-lg" />, text: "Accelerates disease detection with biomarker-based diagnostics." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Reduces healthcare costs by preventing ineffective treatments." }
];
const cmsFeatures = [
    {
        icon: <FaUserMd className="text-[#2a627a] text-lg" />,
        title: "Genomic Researcher",
        text: "Analyzes genetic data to develop targeted therapies and personalized treatment plans."
    },
    {
        icon: <FaDna className="text-[#2a627a] text-lg" />,
        title: "Precision Medicine Specialist",
        text: "Utilizes genetic and molecular insights to customize treatments for individual patients."
    },
    {
        icon: <FaMicroscope className="text-[#2a627a] text-lg" />,
        title: "Biomedical Scientist",
        text: "Conducts laboratory research on biomarkers and drug interactions for personalized care."
    },
    {
        icon: <FaClipboardList className="text-[#2a627a] text-lg" />,
        title: "Clinical Pharmacogeneticist",
        text: "Studies how genetic variations affect individual drug responses."
    }
];
const PersonalizedMedicine = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex"> Personalized Medicine - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Delivering individualized care by leveraging genetic, clinical, and lifestyle data to optimize treatment outcomes."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]"> What is Personalized Medicine?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Personalized medicine tailors medical treatments to individual patients based on their genetic profile, lifestyle,
                            and specific health conditions. At HIKEHEALTH GS, we leverage advanced biotechnology, genomic research, and data-driven
                            insights to develop targeted therapies that improve treatment efficacy and reduce side effects. Our approach ensures
                            precision healthcare, optimizing patient outcomes through customized medical solutions.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Personalized Medicine
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default PersonalizedMedicine;
